import React, { useRef } from "react";
import PropTypes from "prop-types";
import { isBreakpoint } from "../utility/WindowSizeHooks"
import PublicCatalogNavbar from "./partials/PublicCatalogNavbar"
import MuiLayout from "./MuiLayout"
import PublicCatalogFooter from "./footer/PublicCatalogFooter";
import { isClient } from "@/utility/UserUtils";
import ErrorBoundary from "@/utility/ErrorBoundary";
import UserContext from "@/context/UserContext";
import { ConfirmProvider } from "material-ui-confirm";
const PublicCatalogLayout =  (props) => {
  const navBarRef = useRef();
  const {children, subHeader, breadcrumbs, user, renter, classNames = {}} = props;

  const onBodyClick = () => {
    try {
      navBarRef.current.toggleUserMenu(false)
      navBarRef.current.searchButtonRef.current.toggleMenu(false)
    } catch (e) {

    }
  }

  const getUserProfileClass = (user) => {
    if (renter) {
      if(renter.color_scheme == "red") {
        return "red-renter-catalog"
      }
      return "renter-catalog"
    }else if(isClient(user)){
      return "renter-catalog"
    }else {
      return "jaguar-catalog"
    }
  }

  return (
    <MuiLayout>
      <ConfirmProvider>
      <UserContext.Provider value={{user: user}}>
        <ErrorBoundary>
          <div className={`catalog-layout ${classNames.body || ""} ${getUserProfileClass(user)}`} onClick={onBodyClick}>
            <PublicCatalogNavbar breadcrumbs={breadcrumbs} subheader={subHeader} {...props} ref={navBarRef}/>
            {subHeader}
            <div className={`catalog-content container ${classNames.container || ""}`}>
              <ErrorBoundary>
                {children}
              </ErrorBoundary>
            </div>
            <PublicCatalogFooter/>
          </div>
        </ErrorBoundary>
      </UserContext.Provider>
      </ConfirmProvider>
    </MuiLayout>
  );
}

export default PublicCatalogLayout;
